import { useState } from "react";

const cards = [
  { id: 1, image: "https://picsum.photos/300/400?1" },
  { id: 2, image: "https://picsum.photos/300/400?2" },
  { id: 3, image: "https://picsum.photos/300/400?3" },
];

export default function CardStack() {
  const [index, setIndex] = useState(0);

  const nextCard = () => {
    setIndex((prev) => (prev + 1) % cards.length);
  };

  return (
    <div className="flex flex-col items-center">
      <div className="relative w-[300px] h-[400px]">
        {cards.map((card, i) => {
          const position = (i - index + cards.length) % cards.length;

          return (
            <div
              key={card.id}
              className={`
                absolute w-full h-full rounded-xl overflow-hidden
                transition-all duration-500 ease-in-out
                ${
                  position === 0
                    ? "z-30 scale-100 opacity-100"
                    : position === 1
                    ? "z-20 scale-95 opacity-60 translate-y-4"
                    : "z-10 scale-90 opacity-30 translate-y-8"
                }
              `}
            >
              <img
                src={card.image}
                className="object-cover w-full h-full"
                alt=""
              />
            </div>
          );
        })}
      </div>

      <button
        onClick={nextCard}
        className="px-4 py-2 mt-6 text-white bg-black rounded"
      >
        Next
      </button>
    </div>
  );
}